module.exports = __webpack_public_path__ + "3b147afd23e0fa4da7a747764e13fde4.pdf";